import { render, staticRenderFns } from "./userInfor.vue?vue&type=template&id=bb18bf12&scoped=true"
import script from "./userInfor.vue?vue&type=script&lang=js"
export * from "./userInfor.vue?vue&type=script&lang=js"
import style0 from "./userInfor.vue?vue&type=style&index=0&id=bb18bf12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb18bf12",
  null
  
)

export default component.exports